var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import isEqual from 'lodash/isEqual';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import Icon from '../icon';
import TimeRange from '../time-range';
import { Styled } from './style';
var MultilineTimeInput = /** @class */ (function (_super) {
    __extends(MultilineTimeInput, _super);
    function MultilineTimeInput(props) {
        var _this = _super.call(this, props) || this;
        _this.getInitialState = function () {
            if (_this.props.values.length) {
                return {
                    timeRangeList: _this.props.values,
                    isDefaultValues: false,
                };
            }
            else {
                return {
                    timeRangeList: _this.props.defaultValues ? _this.props.defaultValues : [],
                    isDefaultValues: true,
                };
            }
        };
        _this.addTimeRange = function () {
            var _a = _this.props, callback = _a.callback, defaultValues = _a.defaultValues;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: __spreadArrays(prevState.timeRangeList, [
                    {
                        start: '00:00',
                        end: '24:00',
                    },
                ]) })); }, callback
                ? function () {
                    if (!isEqual(defaultValues, _this.state.timeRangeList)) {
                        callback(_this.state.timeRangeList);
                    }
                }
                : undefined);
        };
        _this.setTimeRangeStart = function (time, index) {
            var _a = _this.props, callback = _a.callback, defaultValues = _a.defaultValues;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: __spreadArrays(prevState.timeRangeList.slice(0, index), [
                    { start: time, end: prevState.timeRangeList[index].end }
                ], prevState.timeRangeList.slice(index + 1)) })); }, callback
                ? function () {
                    if (!isEqual(defaultValues, _this.state.timeRangeList)) {
                        callback(_this.state.timeRangeList);
                    }
                }
                : undefined);
        };
        _this.setTimeRangeEnd = function (time, index) {
            var _a = _this.props, callback = _a.callback, defaultValues = _a.defaultValues;
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: __spreadArrays(prevState.timeRangeList.slice(0, index), [
                    { start: prevState.timeRangeList[index].start, end: time }
                ], prevState.timeRangeList.slice(index + 1)) })); }, callback
                ? function () {
                    if (!isEqual(defaultValues, _this.state.timeRangeList)) {
                        callback(_this.state.timeRangeList);
                    }
                }
                : undefined);
        };
        _this.removeInput = function (id) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { timeRangeList: prevState.timeRangeList.filter(function (_, index) { return index !== id; }) })); }, function () { return _this.props.callback && _this.props.callback(_this.state.timeRangeList); });
        };
        _this.state = _this.getInitialState();
        return _this;
    }
    MultilineTimeInput.prototype.render = function () {
        var _this = this;
        var _a = this.state, timeRangeList = _a.timeRangeList, isDefaultValues = _a.isDefaultValues;
        return (React.createElement(Styled, { disabled: this.props.disabled },
            timeRangeList.map(function (timeRange, index) { return (React.createElement("div", { key: index, className: "item-row" },
                React.createElement(TimeRange, { key: index, setTimeRangeStart: function (time) { return _this.setTimeRangeStart(time, index); }, setTimeRangeEnd: function (time) { return _this.setTimeRangeEnd(time, index); }, isDefaultValues: isDefaultValues, inverted: _this.props.inverted, disabled: _this.props.disabled, start: timeRange.start, end: timeRange.end }),
                React.createElement(Button, { onClick: function () {
                        _this.removeInput(index);
                    }, tabIndex: "-1", transparent: true },
                    React.createElement(Icon, { name: "remove-fill" })))); }),
            !this.props.disabled &&
                React.createElement(Button, { onClick: this.addTimeRange, transparent: true },
                    React.createElement(Icon, { name: "plus-fill" }),
                    timeRangeList.length > 0 ? (React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.add_more_time", defaultMessage: "Add another time" })) : (React.createElement(FormattedMessage, { id: "ui_component.multiline_time_input.add_specific_time", defaultMessage: "Add specific time" })))));
    };
    MultilineTimeInput.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.timeRangeList === nextProps.values) {
            return {
                timeRangeList: nextProps.values,
                isDefaultValues: false,
            };
        }
        return null;
    };
    return MultilineTimeInput;
}(React.Component));
export default MultilineTimeInput;
//# sourceMappingURL=index.js.map